import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';

class CustomTag extends React.PureComponent {
    render() {
        const { container_class, tag_container_class, label, disable, onClick } = this.props;
        return (
            <div className={container_class}>
                <div className={`ori-flex-row ori-lr-pad-6 ${tag_container_class}`}>
                    <div className="ori-lr-pad-3">{label}</div>
                    {
                        !disable &&
                        <div className="ori-flex-column ori-flex-jc ori-cursor-ptr" onClick={onClick}>
                            <div className="ori-l-pad-3">
                                <Icon type="close" />
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

CustomTag.propTypes = {
    container_class: PropTypes.string,
    tag_container_class: PropTypes.string,
    onClick: PropTypes.func,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disable: PropTypes.bool,
};

CustomTag.defaultProps = {
    container_class: "ori-pad-3",
    tag_container_class: "ori-bg-default ori-border-light ori-font-13 ori-border-radius-10",
    disable: false,
};

export default CustomTag;


// WEBPACK FOOTER //
// ./src/components/customtag/index.js